$(".accordion button").click(function () {
    var currentButton = $(this);
    var currentPanel = currentButton.next();
    var parentWrapper = currentButton.parent();

    if (currentPanel.is(':visible')) {
        // If the current panel is already open, close it
        currentPanel.slideUp('fast', function () {
            parentWrapper.removeClass('expanded');
        });
    } else {
        // If the current panel is not open, close all other panels and open it
        $(".accordion-content").not(currentPanel).slideUp('fast', function () {
            $(this).parent().removeClass('expanded');
            currentPanel.slideDown('fast', function () {
                parentWrapper.addClass('expanded');
            });
        });
    }
});